/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Box,
  FormControl,
  IconButton,
  FormHelperText as MuiFormHelperText,
  styled,
  InputAdornment,
  Typography,
  Link,
} from '@mui/material';
import {useFormik} from 'formik';
import Button from '@jobseeker/lotus/elements/ButtonV2';
import {VersionVariants} from '@jobseeker/lotus/enums';
import {useState} from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import {Eye, HiddenEye} from '@jobseeker/lotus/assets/icons';
import React from 'react';
import * as yup from 'yup';
import {Input} from '@jobseeker/lotus/elements';
import UserService from '@jobseeker/common-core/services/user.service';
import {enqueueSnackbar} from 'notistack';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import Dialog from '@jobseeker/lotus/components/DialogWithBottomSheet';
import {emailTrendy} from '@jobseeker/lotus/assets/images';
import {useAlertCallback, useIsLargeDevice} from '@jobseeker/lotus/hooks';
import userService from '@jobseeker/common-core/services/user.service';
import authService from '@jobseeker/common-core/services/auth.service';
const validationSchemaChangePassword = yup.object({
  newEmail: yup
    .string()
    .email('Please enter a valid email address')
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      'Please enter a valid email address'
    )
    .required('Please enter your new email'),
  password: yup
    .string()
    .required('Please enter your password')
    .matches(/^\S{6,32}$/, 'Password must be 6-32 characters with no spaces'),
});

const FormHelperText = styled(MuiFormHelperText)(() => ({
  position: 'absolute',
}));

const ChangeEmailForm = ({
  onSuccess,
  onError,
  onChange,
  onCancel,
  formValues,
  ...props
}: any) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(
    !!formValues?.newEmail
  );
  const profile = useSelector((state: AppState) => state.user.profile);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: formValues || {
      newEmail: '',
      password: '',
    },
    validationSchema: validationSchemaChangePassword,
    onSubmit: async (values: any) => {
      const resp = await UserService.changeEmail(values);
      if (resp?.error) {
        formik.setFieldError('password', resp?.error.message);
        // enqueueSnackbar(resp?.error.message, {variant: 'error'});
        onError();
      } else {
        // enqueueSnackbar('Password changed successfully', {variant: 'success'});
        dispatch({
          type: 'User/set_user_profile',
          payload: {
            settings: {
              accountSettings: {emailChangeRequestedOn: values.newEmail},
            },
          },
        });
        onSuccess(values);
      }
    },
    validateOnChange: true,
    validateOnBlur: true,
    // validateOnMount: !!formValues.newEmail,
    initialErrors: {
      // newEmail: 'please enter new',
    },
  });

  const onEmailSubmit = async () => {
    formik.setFieldTouched('newEmail', true, true);
    await formik.validateField('newEmail');

    if (formik.errors.newEmail) {
      return;
    }
    try {
      const doesExist = await userService.checkExists(formik.values.newEmail);
      if (doesExist.exists) {
        if (profile?.email !== formik.values.newEmail) {
          formik.setFieldError(
            'newEmail',
            'This email is already in use. For queries, contact us at hello@iimjobs.com'
          );
          return;
        }
        formik.setFieldError(
          'newEmail',
          'Your new email cannot be the same as your current email'
        );
        return;
      }

      setIsEmailSubmitted(true);
      onChange(formik.values);
    } catch (error) {
      console.error('Error checking email existence:', error);
      enqueueSnackbar(
        'There was an issue checking the email. Please try again later.',
        {
          variant: 'error',
        }
      );
    }
  };

  const onForgotPassword = async () => {
    const resInfo = await authService.forgotPassword('forgot', {
      email: profile.email,
    });
    onCancel();
    props.onForgotPassword();
  };
  const isInputEmptyNewEmail = formik.values.newEmail.trim() === '';
  const hasErrorNewEMail =
    formik.touched.newEmail && Boolean(formik.errors.newEmail);
  const isInputEmptyPassword = formik.values.password.trim() === '';
  const hasErrorPassword =
    formik.touched.password && Boolean(formik.errors.password);
  return (
    <Box
      component={'form'}
      onSubmit={e => {
        e.preventDefault();
        formik.handleSubmit();
      }}
    >
      <FormControl
        sx={{
          width: '100%',
          mt: 0.5,
          display: isEmailSubmitted ? 'none' : 'block',
        }}
        error={formik.touched.newEmail && Boolean(formik.errors.newEmail)}
      >
        {/* <Typography variant="subtitle3">Original Password</Typography> */}
        <Input
          variant={VersionVariants.VERSION_THREE}
          type={'email'}
          name="newEmail"
          value={formik.values.newEmail}
          onChange={formik.handleChange}
          error={formik.touched.newEmail && Boolean(formik.errors.newEmail)}
          placeholder="Enter your new email address"
          InputProps={{autoComplete: 'new-email'}}
        />
        {formik.touched.newEmail && Boolean(formik.errors.newEmail) && (
          <Box display={'flex'}>
            <FormHelperText>
              <>{formik?.errors?.newEmail || ''}</>
            </FormHelperText>
          </Box>
        )}
      </FormControl>

      <FormControl
        sx={{
          width: '100%',
          mt: 0.5,
          display: !isEmailSubmitted ? 'none' : 'block',
        }}
        error={formik.touched.password && Boolean(formik.errors.password)}
      >
        {/* <Typography variant="subtitle3">Enter the password</Typography> */}
        <Input
          variant={VersionVariants.VERSION_THREE}
          type={showNewPassword ? 'text' : 'Password'}
          name="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          placeholder="Enter the password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  // onMouseDown={handleMouseDown}
                  // edge="end"
                >
                  {showNewPassword ? (
                    <Image
                      src={Eye}
                      width={15}
                      height={15}
                      alt="show password"
                    />
                  ) : (
                    <Image
                      src={HiddenEye}
                      width={15}
                      height={15}
                      alt="hide password"
                    />
                  )}
                </IconButton>
              </InputAdornment>
            ),
            autoComplete: 'new-password',
          }}
        />

        <Box display={'flex'} justifyContent={'space-between'}>
          <FormHelperText
            sx={{
              opacity:
                formik.touched.password && Boolean(formik.errors.password)
                  ? 1
                  : 0,
              width: {xxs: 'calc(100% - 150px)', md: '100%'},
            }}
          >
            <>{formik?.errors?.password || ''}</>
          </FormHelperText>
          <Typography
            variant="body3"
            pr={2}
            sx={{minWidth: '100%', textAlign: 'right', position: 'absolute'}}
          >
            <Link
              sx={{textDecoration: 'none', cursor: 'pointer'}}
              onClick={onForgotPassword}
            >
              Forgot Password?
            </Link>
          </Typography>
        </Box>
      </FormControl>

      <Box display={'flex'} gap={1.5} mt={4} mb={2}>
        <Button
          color="secondary"
          variant="contained"
          // disabled={}
          // type="submit"
          disabled={
            hasErrorNewEMail ||
            isInputEmptyNewEmail ||
            (isEmailSubmitted && (hasErrorPassword || isInputEmptyPassword))
          }
          onClick={isEmailSubmitted ? formik.handleSubmit : onEmailSubmit}
        >
          {isEmailSubmitted ? 'Confirm' : 'Send Verification'}
        </Button>
        <Button onClick={onCancel} color="primary" variant="outlined">
          Cancel
        </Button>
      </Box>
    </Box>
  );
};
export const EmailAddressComponent: React.FC<object> = ({}) => {
  // const [formValues, setFormValues] = useState({});
  const [isChangeSuccessfull, setIsChangeSuccessfull] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const initialHeaders = {
    title: 'Enter your new email address',
    subtitle: 'We will send you a verification mail on this email address',
  };
  const [alertHeaders, setAlertHeaders] = useState(initialHeaders);
  const dispatch = useDispatch();
  const isLarge = useIsLargeDevice();

  const toggleChangeEmail = () => {
    setDialogOpen(op => !op);
    setTimeout(() => {
      setAlertHeaders(initialHeaders);
    }, 50);
  };
  // const [ChangeEmailDialog, toggleChangeEmail, setAlertHeaders] =
  //   useAlertCallback(initialEmailDialogContent);
  const onChange = (values: any) => {
    if (values.newEmail) {
      // setFormValues(values);
      setAlertHeaders({
        title: 'Please enter your password to confirm the change',
        subtitle: `To proceed with changing your email, we'll send a 
verification to ${values.newEmail}`,
      });
    }
  };

  const profile = useSelector((state: AppState) => state.user.profile);
  const onEmailChangeSuccess = (values: any) => {
    setAlertHeaders({
      title: `Please click the verification link sent to ${values.newEmail}
to complete the change
`,
      subtitle: `Meanwhile, you can continue accessing your account by using your 
current email i.e ${profile.email}`,
    });
    setIsChangeSuccessfull(true);
  };

  const [ForgotPasswordDialog, toggleForgotPassword] = useAlertCallback({
    title: (
      <>
        We’ve sent an email to {profile.email || 'your email'}
        <br /> Click the link in the email to reset your password.
      </>
    ),
    subtitle:
      'If you don’t see the email, check other places it might be, like your junk, spam, social, or other folders.',
    primaryAction: 'Okay',
    // secondaryAction: 'Cancel',
    primaryCallback: console.log,
    useBottomSheet: true,
  });

  const cancelEmailChangeRequest = async () => {
    const resp = await userService.cancelEmailChange();
    if (resp.error) {
      enqueueSnackbar(resp.error.message, {variant: 'error'});
    } else {
      dispatch({
        type: 'User/set_user_profile',
        payload: {
          settings: {
            accountSettings: {emailChangeRequestedOn: ''},
          },
        },
      });
      enqueueSnackbar('email change request cancelled successfully', {
        variant: 'success',
      });
      setIsChangeSuccessfull(false);
      setAlertHeaders(initialHeaders);
    }
  };

  const [CancelRequestDialog, toggleCancelRequestDialog] = useAlertCallback({
    title: (
      <>
        Are you sure you want to cancel your email change request?
        <br />
        You can always reinitiate it later.
      </>
    ),
    subtitle: ``,
    primaryAction: 'Cancel Request',
    secondaryAction: 'Cancel',
    primaryCallback: cancelEmailChangeRequest,
    useBottomSheet: true,
  });

  const [isResendDialogOpen, setResentDialogOpen] = useState(false);

  const toggleResentEmailDialog = async () => {
    if (!isResendDialogOpen) {
      await userService.resentChangeEmail();
    }
    setResentDialogOpen(op => !op);
  };
  return (
    <>
      <Dialog
        open={dialogOpen}
        onClose={toggleChangeEmail}
        title={alertHeaders.title}
        subTitle={alertHeaders.subtitle}
        sx={{}}
      >
        {!isChangeSuccessfull ? (
          <ChangeEmailForm
            // formValues={formValues}
            onSuccess={onEmailChangeSuccess}
            onChange={onChange}
            onError={console.log}
            onCancel={toggleChangeEmail}
            onForgotPassword={toggleForgotPassword}
          />
        ) : (
          <Box mt={3} mb={2}>
            <Button
              color="secondary"
              variant="contained"
              onClick={toggleChangeEmail}
            >
              Okay
            </Button>
          </Box>
        )}
      </Dialog>
      <Box
        color="gray.dark"
        onClick={() => {}}
        data-testid="notification_list_item"
        sx={{
          position: 'relative',
          transition: 'all ease 0.2s',
          // cursor: 'pointer',
          borderBottom: 'solid 1px',
          borderColor: 'border.lightGray',
        }}
      >
        <Box
          sx={{
            py: {xxs: 1.5, md: 2},
            px: {xxs: 1.5, md: 2},
          }}
        >
          <Box
            display={'flex'}
            width={'100%'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Box display={'flex'} flexDirection={'column'} width={'100%'}>
              <Typography
                variant="subtitle2"
                color={'text.primary'}
                sx={{
                  lineClamp: '3',
                  '-webkit-line-clamp': '2',
                  '-webkit-box-orient': 'vertical',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  wordWrap: 'break-word',
                  display: 'block',
                  alignItems: 'center',
                }}
              >
                Email Address:&nbsp;{profile.email}
              </Typography>
              {profile.settings?.accountSettings?.emailChangeRequestedOn ? (
                <>
                  <Box
                    display={'flex'}
                    gap={1.5}
                    sx={{background: '#91B87929'}}
                    borderRadius={2}
                    width={'100%'}
                    py={2}
                    mt={1}
                    px={1}
                  >
                    <Box>
                      <Image
                        src={emailTrendy}
                        alt={''}
                        width={40}
                        height={40}
                      />
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" color={'text.primary'}>
                        You have initiated an email change request
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        fontSize={{xxs: 12, md: 14}}
                        lineHeight={'16px'}
                      >
                        To confirm, click on the verification link sent on
                        your&nbsp;
                        <Typography
                          component={'span'}
                          variant="subtitle2"
                          fontSize={{xxs: 12, md: 14}}
                          color={'text.primary'}
                        >
                          New Email:{' '}
                          {
                            profile.settings?.accountSettings
                              ?.emailChangeRequestedOn
                          }
                          <br />
                        </Typography>
                      </Typography>
                      <Box
                        sx={{display: {xxs: 'block', md: 'flex'}}}
                        mt={'12px'}
                      >
                        <Typography
                          variant="subtitle3"
                          color="var(--Grey-font-Color, #7E7E7E)"
                        >
                          Didn’t receive the email?&nbsp;
                        </Typography>
                        <Typography
                          onClick={toggleResentEmailDialog}
                          sx={{
                            padding: '0px',
                            fontSize: '12px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            color: 'primary.main',
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          Resend Verification email
                        </Typography>
                      </Box>
                      <Box
                        sx={{display: {xxs: 'block', md: 'flex'}}}
                        mt={'8px'}
                      >
                        <Typography
                          variant="subtitle3"
                          color="var(--Grey-font-Color, #7E7E7E)"
                        >
                          Changed your mind?&nbsp;
                          {isLarge ? '' : <br />}
                        </Typography>
                        <Typography
                          variant="subtitle3"
                          onClick={toggleCancelRequestDialog}
                          sx={{
                            padding: '0px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            fontWeight: '500',
                            color: 'primary.main',
                            '&:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                        >
                          Cancel request
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
              ) : (
                <Button
                  variant="text"
                  onClick={toggleChangeEmail}
                  sx={{
                    padding: '0px',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: 'var(--brand-color, #49966E)',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  Change Email
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Dialog
        open={isResendDialogOpen}
        onClose={toggleResentEmailDialog}
        title={`Please click the verification link resent to ${profile?.settings?.accountSettings?.emailChangeRequestedOn} to complete the change`}
        subTitle={`Meanwhile, you can continue accessing your account by using your 
current email i.e ${profile.email}`}
        headerStyles={{boxShadow: 'none', border: 'none'}}
      >
        <Box mb={2} mt={3}>
          <Button
            color="secondary"
            variant="contained"
            onClick={toggleResentEmailDialog}
          >
            Okay
          </Button>
        </Box>
      </Dialog>
      <ForgotPasswordDialog />
      <CancelRequestDialog />
    </>
  );
};
